// extracted by mini-css-extract-plugin
export default {"loadingPage":"loading-page_loadingPage__Tn+Lx","spinner":"loading-page_spinner__sFEUX","loadingText":"loading-page_loadingText__b5wgW"};